export default __webpack_public_path__ + "static/media/icon-cancel.a4effd9f.svg";